<template>
    <div>
        <h1>Patch Notes:</h1>
        <br/><span style="font-size:18px"><span style="color:red">NOTE:</span> Patch notes are not as up to date here, if you'd like to get up to date patch notes, check out the discord: <a href="https://discord.gg/ZTrp4aS7C3">Discord</a></span>
       <br/><br/>
       <patch-1-point-2></patch-1-point-2>
       <patch-1-point-1></patch-1-point-1>
    </div>
</template>
<script>
import {
} from "vuetify/lib";
import Patch1Point1 from "./patchNotes/patch1.1"
import Patch1Point2 from "./patchNotes/patch1.2"
export default {
  components: {    
    Patch1Point1,
    Patch1Point2,
  },
}
</script>
